import { useEffect } from 'react';
import prototype from '../config/prototype.json';

const SITE_NAME = 'Herculean Homes';
// TEMPORARY — see src/components/Prototype.tsx.
const SUFFIX = prototype.enabled ? ' (Prototype)' : '';

/** Sets a per-route <title>. Native browser API, no dependency required. */
export function useDocumentTitle(pageTitle?: string) {
  useEffect(() => {
    document.title =
      (pageTitle ? `${pageTitle} — ${SITE_NAME}` : `${SITE_NAME} — Custom Built`) +
      SUFFIX;
  }, [pageTitle]);
}
